module.exports = __webpack_public_path__ + "static/media/defaultwhite.4cd3bd40.svg";